import { PlaycastData, initialPlaycastData } from './player/types';
import { ReactNode, createContext, useEffect, useState, useSyncExternalStore } from 'react';
import { store } from './player/store';
import { gamepadStore } from '@playcastdotio/MobileGamepad';
import { setGamepadState } from '../api/modules/hostMessaging/inputEvents';

export const PlaycastContext = createContext<PlaycastData>(initialPlaycastData);

type LocalProps = {
  children?: ReactNode;
};

export const PlayerContext = (props: LocalProps) => {
  const { children } = props;
  const [data, setData] = useState<PlaycastData>(store.getData());
  const gamepad = useSyncExternalStore(gamepadStore.subscribeGamepad, gamepadStore.getGamepad);

  useEffect(() => {
    if (gamepad) {
      setGamepadState(gamepad);
    }
  }, [gamepad]);

  const dataHandler = () => {
    console.log('data refresh');
    const d = store.getData();
    setData({ ...d });
  };

  useEffect(() => {
    console.log('adding event listener, data refresh');
    window.addEventListener('playcastDataRefreshed', dataHandler);
    return () => {
      console.log('removing event listener, data refresh');
      window.removeEventListener('playcastDataRefreshed', dataHandler);
    };
  }, []);

  // const connectionChangedHandler = () => {
  //   const newState = store.getData().peerManager?.dataConnectionState || 'invalid';
  //   console.log('data connection state: '.concat(newState));
  // };

  // useEffect(() => {
  //   console.log('adding event listener, data connection change');
  //   window.addEventListener('playcastDataConnectionChanged', connectionChangedHandler as EventListener);
  //   return () => {
  //     console.log('removing event listener, data connection change');
  //     window.removeEventListener('playcastDataConnectionChanged', connectionChangedHandler as EventListener);
  //   };
  // }, []);

  return <PlaycastContext.Provider value={data}>{children}</PlaycastContext.Provider>;
};
